
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHeavySleetShowersDay as ObiHeavySleetShowersDayElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-heavy-sleet-showers-day.js';
 
 
 

 
 export const ObiHeavySleetShowersDay = createComponent({
   react: React,
   tagName: 'obi-heavy-sleet-showers-day',
   elementClass: ObiHeavySleetShowersDayElement,
   events: {
     
   }
  });
 
 